// global
import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Input, Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
// local
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { PROFILE } from 'salvus-shared/consts/account';
// views
import CustomToggle from './CustomToggle';
import CylinderLabel from './CylinderLabel';
import DeviceLabel from './DeviceLabel';
import MonitorTableRow from './MonitorTableRow';
import MonitorMap from './MonitorMap';
import MapLabel from './MapLabel';
import ListLabel from './ListLabel';
import Page from 'app/ui/pages/Page';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
import FilterUseType from 'app/ui/commons/filterusertype/FilterUseType';
// actions
import { updateAutoUpdate, updateView, oxigenByPatient, search, filter, reset } from 'app/redux/actions/monitor';
// css
import './Monitor.css';

class Monitor extends Component {
    constructor(props) {
        super(props);
        this.callSearch = _.debounce(this.callSearch, 100);
        this.state = {
            search: props.monitor.filter.term,
        };
    }

    componentDidMount() {
        this.requestData();
        // check if the default is auto update
        if (this.props.monitor.autoUpdate) {
            this.registerForUpdate();
        }
    }

    componentWillUnmount() {
        this.unregisterForUpdate();
        this.props.dispatch(reset());
    }

    componentDidUpdate(prevProps) {
        // check the new auto update value
        let { autoUpdate: pAutoUpdate } = prevProps.monitor;
        let { autoUpdate: cAutoUpdate } = this.props.monitor;
        if (cAutoUpdate !== pAutoUpdate) {
            if (cAutoUpdate) {
                this.registerForUpdate();
            } else {
                this.unregisterForUpdate();
            }
        }
    }

    registerForUpdate() {
        this.unregisterForUpdate();
        this.interval = setInterval(this.requestData.bind(this), 10000);
    }

    unregisterForUpdate() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    requestData = () => {
        this.props.dispatch(oxigenByPatient());
    };

    onRequestClicked = () => this.props.dispatch(push('/request-delivery'));

    onViewChanged = view => () => this.props.dispatch(updateView(view));

    // Handler for the events from the Auto-update Checkbox
    onUpdateChanged = e => this.props.dispatch(updateAutoUpdate(e.target.checked));

    // Handler for the events from the filter Checkbox
    onFilterChange = value => this.props.dispatch(filter(value));

    // Handler for the change in the input
    onSearchChange = (e, { value }) => {
        this.setState({ search: value });
        this.callSearch(value);
    };

    callSearch = value => this.props.dispatch(search(value));

    renderEmpty = () => <EmptyList emptyMessage="Nenhum paciente encontrado." />;

    renderMap = filter => <MonitorMap data={filter.data} monitor={this.props.monitor} dispatch={this.props.dispatch} />;

    renderTable(filter, account) {
        return (
            <Table id="monitor-table">
                <Table.Header>
                    <Table.Row className="h-table">
                        <Table.HeaderCell width={1} textAlign="center">
                            TIPO
                        </Table.HeaderCell>
                        <Table.HeaderCell>PACIENTE</Table.HeaderCell>
                        <Table.HeaderCell width={1} textAlign="center">
                            MAPA
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} textAlign="center">
                            <p>Prescrição</p>
                            <p className="lowercase italic">(l/min)</p>
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} textAlign="center">
                            <p>FLUXO</p>
                            <p className="lowercase italic">(l/min)</p>
                        </Table.HeaderCell>
                        <Table.HeaderCell width={2} textAlign="center">
                            TÉRMINO
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} textAlign="center">
                            DISPOSITIVO <span> (status) </span> <DeviceLabel />
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            CILINDROS <CylinderLabel />
                        </Table.HeaderCell>
                        <Table.HeaderCell width={2} textAlign="center">
                            REPOSIÇÃO
                        </Table.HeaderCell>
                        {!this.isSalvusUser(account) && <Table.HeaderCell collapsing />}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(filter.data, patient => {
                        const key = `patient-${patient.id}`;
                        return <MonitorTableRow key={key} row={patient} dispatch={this.props.dispatch} account={account} />;
                    })}
                </Table.Body>
            </Table>
        );
    }

    isSalvusUser(account) {
        if (account.client.type === CLIENT_TYPE.SALVUS && account.profile === PROFILE.DEFAULT) {
            return true;
        }
        return false;
    }

    render() {
        const { account } = this.props.auth;
        const { loading, cylinderUpdates, autoUpdate, filter, view } = this.props.monitor;
        return (
            <Page id="page-monitor" loading={loading}>
                <div className="page-header">
                    <div className="page-title">MONITORAMENTO {view === 'list' ? <ListLabel /> : <MapLabel />}</div>
                    <div>
                        {!this.isSalvusUser(account) && view === 'list' && (
                            <Button className="with-label" disabled={cylinderUpdates === 0} onClick={this.onRequestClicked}>
                                SOLICITAR
                                <div className="label">{cylinderUpdates}</div>
                            </Button>
                        )}
                    </div>
                </div>
                <div className="body">
                    <div className="body-header">
                        <div id="monitor-filters">
                            <Input id="monitor-search" placeholder="Pesquisar..." className="search" onChange={this.onSearchChange} value={this.state.search} />
                            <FilterUseType checked={filter.type} onChange={this.onFilterChange} />
                        </div>
                        <div id="auto-update">
                            {/* Atualização Automática: <CustomToggle className="toggle-update" checked={autoUpdate} onChange={this.onUpdateChanged} /> */}
                            {view === 'list' && 'Atualização Automática: '}
                            {view === 'list' && <CustomToggle className="toggle-update" checked={autoUpdate} onChange={this.onUpdateChanged} />}
                            <Button circular active={view === 'list'} icon="list" size="tiny" id="monitor-button-list" onClick={this.onViewChanged('list')} />
                            <Button
                                circular
                                active={view === 'map'}
                                icon="map outline"
                                size="tiny"
                                id="monitor-button-map"
                                onClick={this.onViewChanged('map')}
                            />
                        </div>
                    </div>
                    {_.isEmpty(filter.data) ? this.renderEmpty() : view === 'list' ? this.renderTable(filter, account) : this.renderMap(filter, account)}
                </div>
            </Page>
        );
    }
}

Monitor.propTypes = {
    auth: PropTypes.object,
    dispatch: PropTypes.func,
    monitor: PropTypes.object,
};

const mapStateToProps = state => ({
    auth: state.auth,
    monitor: state.monitor,
});
export default connect(mapStateToProps)(Monitor);
